import { render, staticRenderFns } from "./password_update.vue?vue&type=template&id=6e25d7a1&scoped=true&"
import script from "./password_update.vue?vue&type=script&lang=js&"
export * from "./password_update.vue?vue&type=script&lang=js&"
import style0 from "./password_update.vue?vue&type=style&index=0&id=6e25d7a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25d7a1",
  null
  
)

export default component.exports